// extracted by mini-css-extract-plugin
export default {"filterBlock":"styles_filterBlock__NiPRE","inputsContainer":"styles_inputsContainer__jq8VF","search":"styles_search__3wL69","searchIcon":"styles_searchIcon__H3sYi"};